module.exports = __webpack_public_path__ + "img/45.07bd8330.jpg";